import { useContext, useState } from "react";
import "../../../css/azienda.css";
import useFetch from "../../../hooks/useFetch";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import LanguageContext from "../../../context/language-context";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ScrollTrigger from "react-scroll-trigger";
import BoxReveal from "../../UI/BoxReveal";
import { Link } from "react-router-dom";
export default function Brand() {
  const [inView, setInView] = useState(false);

  const translations = {
    en: {
      more: "Read More",
      less: "Read Less",
    },
    fr: {
      more: "Lire Plus",
      less: "Lire Moins",
    },
    de: {
      more: "Mehr Lesen",
      less: "Weniger Lesen",
    },
    ru: {
      more: "Читать далее",
      less: "Читать меньше",
    },
    es: {
      more: "Leer Más",
      less: "Leer Menos",
    },
    it: {
      more: "SCOPRI ",
      less: "Leggi Meno",
    },
  };

  const languageCtx = useContext(LanguageContext);
  const { loading, error, data } = useFetch(
    `https://spagnoladmin.spagnolcompany.it/api/brands?locale=${languageCtx.languageData}&populate[0]=Brand.Image&populate[1]=Brand.Innerpage_details`
  );

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data</p>;

  const { data: details, meta } = data;

  return (
    <div className="mg-3 brand">
      <section className="intro maxWidth" data-scroll-section="">
        <div className="brand-heading">
          <h2>{details[0].attributes.Title}</h2>
          <h1>{details[0].attributes.Info}</h1>
        </div>
      </section>
      <div className="first-section">
        <ScrollTrigger
          onEnter={() => setInView(true)}
          onExit={() => setInView(false)}
        >
          {details[0].attributes.Brand.map((item, index) => {
            const isReversed = (index + 1) % 2 === 0;
            const bgColor = `bg-color-${index % 5}`;

            return (
              <BoxReveal key={index} boxColor="#fff">
                <Link to={`/brand/${item.Heading.toLowerCase()}`}>
                  <div
                    className={`section-inner fullscreen my-2 slide-up ${bgColor} ${
                      isReversed ? "row-reverse" : ""
                    } ${inView ? "inview" : ""}`}
                  >
                    <div className="left-text">
                      <h1>{item.Heading}</h1>
                      <BlocksRenderer
                        content={item.Preview}
                        blocks={{
                          paragraph: ({ children }) => (
                            <p className="mt-4 text-base lg:text-xl">
                              {children}
                            </p>
                          ),
                          heading: ({ children, level }) => {
                            const Tag = `h${level}`;
                            return (
                              <Tag className="mt-4 font-bold text-base lg:text-2xl">
                                {children}
                              </Tag>
                            );
                          },
                          list: ({ children, format }) =>
                            format === "unordered" ? (
                              <ul className="list-disc list-inside ml-6 mt-4">
                                {children}
                              </ul>
                            ) : (
                              <ol className="list-decimal list-inside ml-6 mt-4">
                                {children}
                              </ol>
                            ),
                          quote: ({ children }) => (
                            <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                              {children}
                            </blockquote>
                          ),
                          link: ({ children, url }) => (
                            <Link to={url} className="text-footer underline">
                              {children}
                            </Link>
                          ),
                        }}
                      />
                      <br />
                      <span className="underline-hover-effect">
                        {translations[languageCtx.languageData].more}
                      </span>
                    </div>
                    <div className="right-text curve">
                      <div className="hovereffect">
                        <img
                          src={`https://spagnoladmin.spagnolcompany.it${
                            item.Image?.data?.attributes?.url || ""
                          }`}
                          alt={item.Heading}
                        />
                      </div>
                    </div>
                  </div>
                </Link>
              </BoxReveal>
            );
          })}
        </ScrollTrigger>
      </div>
    </div>
  );
}
